var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHacken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 88,
    viewBox: "0 0 840 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0V32H24V0H0V88H24V56H96V88H120V0H96Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 56H528V88H552V56Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 0H528V32H456V0H432V88H456V56H528L552 32V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 0H144V88H168V56H240V88H264V0H248ZM168 32V24H240V32H168Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408 24V0H312H304H288V88H304H312H408V64H312V24H408Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696 24V0H600H592H576V88H592H600H696V64H600V56H696V32H600V24H696Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 0V56L744 0H720V88H744V32L816 88H840V0H816Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 840,
    height: 88,
    fill: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHacken);
export default __webpack_public_path__ + "static/media/logo-hacken.bfb6661d37e0c3b7be46b035b407868b.svg";
export { ForwardRef as ReactComponent };